import { useEffect, useRef } from 'react';

const useModalEnterNavigation = (isModalOpen, formRefs = {}) => {
  // formRefs referansı her render'da değişse bile etkilenmeyecek
  const refsRef = useRef(formRefs);
  refsRef.current = formRefs;

  useEffect(() => {
    if (!isModalOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        const activeElement = document.activeElement;
        
        // Eğer aktif element bir input, select veya textarea ise
        if (activeElement && (
          activeElement.tagName === 'INPUT' || 
          activeElement.tagName === 'SELECT' || 
          activeElement.tagName === 'TEXTAREA'
        )) {
          // Submit button değilse
          if (activeElement.type !== 'submit' && activeElement.type !== 'button') {
            event.preventDefault();
            
            // FormRefs varsa onları kullan
            const currentRefs = refsRef.current || {};
            if (Object.keys(currentRefs).length > 0) {
              const refKeys = Object.keys(currentRefs);
              const currentRefKey = refKeys.find(key => 
                currentRefs[key].current === activeElement
              );
              
              if (currentRefKey) {
                const currentIndex = refKeys.indexOf(currentRefKey);
                const nextIndex = (currentIndex + 1) % refKeys.length;
                const nextRef = currentRefs[refKeys[nextIndex]];
                
                if (nextRef && nextRef.current) {
                  nextRef.current.focus();
                  if (nextRef.current.select) {
                    nextRef.current.select();
                  }
                }
                return;
              }
            }
            
            // Normal navigasyon
            const modalElement = activeElement.closest('.modal, .MuiDialog-root, [role="dialog"]');
            if (modalElement) {
              const focusableElements = modalElement.querySelectorAll(
                'input:not([disabled]):not([type="hidden"]), ' +
                'select:not([disabled]), ' +
                'textarea:not([disabled]), ' +
                'button:not([disabled])'
              );
              
              const focusableArray = Array.from(focusableElements);
              const currentIndex = focusableArray.indexOf(activeElement);
              
              if (currentIndex !== -1 && currentIndex < focusableArray.length - 1) {
                const nextElement = focusableArray[currentIndex + 1];
                nextElement.focus();
                
                if (nextElement.tagName === 'INPUT' && nextElement.type === 'text') {
                  nextElement.select();
                }
              }
            }
          }
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);
};

export default useModalEnterNavigation; 